import { defineComponent as _defineComponent } from 'vue'
import { useRoute } from '@nuxtjs/composition-api';
import { computed, ref, watch } from 'vue';
import { useElementHover } from '@vueuse/core';

interface Props {
  headerRef?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeaderMenu',
  props: {
    headerRef: null
  },
  setup(__props: any) {

const props = __props as {
  headerRef?: any;
};


const route = useRoute();
const menu = computed(() => props.headerRef);
const isHovered = useElementHover(menu);
const activeItem = ref(null);
const setActiveItem = (index) => {
  activeItem.value = index;
};

watch(isHovered, (value) => {
  if (value === false) activeItem.value = null;
});

watch(route, () => {
  activeItem.value = null;
});

return { __sfc: true,props, route, menu, isHovered, activeItem, setActiveItem }
}

})